module.exports = __webpack_public_path__ + "img/pic1.2fa03330.jpg";